module.exports = __webpack_public_path__ + "img/download-code-test.c949e28e.png";